import { FC } from 'react'
import { Button } from '~/application/components/Button/Button'
import { SponsorRequessModal } from '~/domain/sponsor/components/SponsorRequestModal/SponsorRequestModal'
import { useSponsorRequestButton, Props } from './useSponsorRequestButton'

export const SponsorRequestButton: FC<Props> = (props) => {
  const { user, isOpenModal, canSponsorRequest, onClick, onCloseModal } =
    useSponsorRequestButton(props)

  return (
    <>
      {canSponsorRequest && (
        <>
          <Button onClick={onClick} color="primary">
            スポンサー申請を送る
          </Button>
          <SponsorRequessModal
            isOpen={isOpenModal}
            onClose={onCloseModal}
            user={user}
          />
        </>
      )}
      {!canSponsorRequest && <Button disabled={true}>スポンサー申請中</Button>}
    </>
  )
}
